import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ReportService } from "../report.service";
//Import Custom Services Here
import { SchoolService } from "../../../shared/services/school.service";
import { StartMonthService } from "../report-services/start-month.service";
import { StartYearService } from "../report-services/start-year.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";

@Component({
	templateUrl: "./attendancebyday.component.html",
})
export class AttendancebyDayComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private startyearService: StartYearService,
		private startmonthService: StartMonthService,
		private schoolService: SchoolService,
		private dialogService: DialogService
	) {}
	report = {
		//Insert Custom Parameters Here
		SchoolID: 0,
		PcentBaseAttendance: 0,
		BaseStudentsCutting: 0,
		BaseClassCutsPerDay: 0,
		MonthID: 0,
		YearID: 0,
		ImageLogo: "",
	};
	//Insert Custom Lists Here
	schoolList: any = [];
	MonthList: any = [];
	YearList: any = [];
	ImageLogoList: any = [];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 3;
	subscription: any;

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;
	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadSchoolist()
		// this.loadMonthList()
		// this.loadYearList()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadMonthList();
		this.loadYearList();
		this.loadLogolist();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(3);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	private loadMonthList() {
		this.report.MonthID = 0;
		var result = this.startmonthService.loadStartMonthList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.MonthList = response;

				if (this.MonthList.length > 1) {
					// this.MonthList.unshift({
					//     MonthID: 0,
					//     MonthDesc: "All Months"
					// })
					this.report.MonthID = this.MonthList[0].MonthID;
				} else {
					this.report.MonthID = this.MonthList[0].MonthID;
				}
			},
			(error) => {}
		);
	}

	private loadYearList() {
		this.report.YearID = 0;
		var result = this.startyearService.loadStartYearList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.YearList = response;

				if (this.YearList.length > 1) {
					// this.YearList.unshift({
					//     YearID: 0,
					//     YearDesc: "All Years"
					// })
					this.report.YearID = this.YearList[0].YearID;
				} else {
					this.report.YearID = this.YearList[0].YearID;
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		// //Insert Custom Error Checks Here
		// if (!this.report.SchoolID) {
		// 	this.errorMessage = "Select the School"
		// 	return;
		// }

		///////////////////////////////////////////////////////////////////
		//START Percent Base Attendance Error Checking
		///////////////////////////////////////////////////////////////////

		//Not a number
		if (isNaN(this.report.PcentBaseAttendance)) {
			this.errorMessage = "Please Enter a number for Base Attendance %";
			return;
		}

		//Out of range (Must be between 0-100 inclusive)
		if (this.report.PcentBaseAttendance < 0 || this.report.PcentBaseAttendance > 100) {
			this.errorMessage = "Select a Base Attendance % between 0 and 100";
			return;
		}

		///////////////////////////////////////////////////////////////////
		//END Percent Base Attendance Error Checking
		///////////////////////////////////////////////////////////////////

		///////////////////////////////////////////////////////////////////
		//START Base Students Cutting Error Checking
		///////////////////////////////////////////////////////////////////

		//Not a number
		if (isNaN(this.report.BaseStudentsCutting)) {
			this.errorMessage = "Please Enter a number for Base Students Cutting";
			return;
		}

		///////////////////////////////////////////////////////////////////
		//END Base Students Cutting Error Checking
		///////////////////////////////////////////////////////////////////

		///////////////////////////////////////////////////////////////////
		//START Base Class Cuts Error Checking
		///////////////////////////////////////////////////////////////////

		//Not a number
		if (isNaN(this.report.BaseClassCutsPerDay)) {
			this.errorMessage = "Please Enter a number for Base Students Cutting";
			return;
		}

		///////////////////////////////////////////////////////////////////
		//END Base Class Cuts Error Checking
		///////////////////////////////////////////////////////////////////

		// if (!this.report.MonthID) {
		// 	this.errorMessage = "Select the StartMonth"
		// 	return;
		// }

		// if (!this.report.YearID) {
		// 	this.errorMessage = "Select the StartYear"
		// 	return;
		// }

		this.isProcessing = true;

		var component = this;
		this.errorMessage = "";

		var strParam = this.GetStrParam();

		var result = this.reportService.Print(this.ReportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Insert Custom Parameters Here
		//Parameter 1: SchoolID
		strParam += this.report.SchoolID + "|SchoolID";

		//Parameter 2: PcentBaseAttendance
		strParam += "," + this.report.PcentBaseAttendance + "|PcentBaseAttendance";

		//Parameter 3: BaseStudentsCutting
		strParam += "," + this.report.BaseStudentsCutting + "|BaseStudentsCutting";

		//Parameter 4: BaseClassCutsPerDay
		strParam += "," + this.report.BaseClassCutsPerDay + "|BaseClassCutsPerDay";

		//Parameter 5: StartMonthID
		strParam += "," + this.report.MonthID + "|StartMonthID";

		//Parameter 6: StartYearID
		strParam += "," + this.report.YearID + "|StartYearID";

		//Parameter 7: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
